import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './assets/icons/edit-alt.svg'
import _imports_1 from './assets/icons/clipboard-notes.svg'


const _withScopeId = n => (_pushScopeId("data-v-431ec384"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]

import MicrogestureComponent from './MicrogestureComponent'
import { ref, provide, computed } from 'vue'


export default {
  __name: 'MicrogestureInput',
  props: {
  modelValue: {
    type: Object
  },
  allowEditButton: {
    type: Boolean,
    default: true
  },
  autoPaste: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: emits }) {

const props = __props;




const microgesture = computed({
  get () {
    return props.modelValue ?? { type: 'in-construction' }
  },
  set (value) {
    emits('update:modelValue', value)
  }
})
const microgestureComponent = ref({}) // dictionary of components inside microgesture

const hoveredInputButton = ref(undefined)
const trashMode = ref(false)

const reload = ref(0)

const inConstruction = ref(!props.allowEditButton)

provide('microgestureComponent', microgestureComponent)
provide('hoveredInputButton', hoveredInputButton)
provide('trashMode', trashMode)
provide('inConstruction', inConstruction)

async function paste () {
  const text = await navigator.clipboard.readText()
  const temp = JSON.parse(text)
  if (temp.microgesture) {
    microgesture.value = temp.microgesture
  }
}

if (props.autoPaste) {
  paste()
}

function addQuantificator (type) {
  if (microgesture.value.type !== 'seq') {
    const o = {
      type: 'seq',
      quantificators: { },
      seq: JSON.parse(JSON.stringify(microgesture.value))
    }
    o.quantificators[type] = [[]]
    microgesture.value = o
  } else {
    if (!microgesture.value.quantificators[type]) {
      microgesture.value.quantificators[type] = []
    }
    microgesture.value.quantificators[type].push([])
  }
}

provide('addQuantificator', addQuantificator)

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(), _createBlock(_unref(MicrogestureComponent), {
      modelValue: _unref(microgesture),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (_isRef(microgesture) ? (microgesture).value = $event : null)),
      key: reload.value
    }, null, 8, ["modelValue"])),
    _hoisted_3,
    (!inConstruction.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "edit-button",
          onClick: _cache[1] || (_cache[1] = $event => (inConstruction.value=true))
        }, _hoisted_5))
      : _createCommentVNode("", true),
    (_unref(microgesture).type==='in-construction')
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "paste-button",
          onClick: paste
        }, _hoisted_7))
      : _createCommentVNode("", true)
  ]))
}
}

}